export const substituteRfe = {
	title: "Facturation électronique de votre remplaçant",
	lead: "Activez la facturation électronique pour {0}",
	description: "Vous disposez déjà d'un pack RFE. Activez un pack RFE pour ce remplaçant afin qu'il puisse émettre et recevoir ses factures électroniques via Osteo2ls.",
	'next-invoice': "Ajouté à votre prochaine facture",
	'prorata-note': "Prorata du {0} jusqu'à la fin de votre abonnement actuel, le {1}.",
	'recurring-annual': "Puis chaque année",
	'recurring-monthly': "Puis chaque mois",
	'monthly-line': "Chaque mois",
	note: "Le montant du pack RFE s'ajoute à votre abonnement actuel.",
	confirm: "activer le pack RFE",
	later: "plus tard",
	success: "Le pack RFE de votre remplaçant a bien été souscrit.",
	failed: "La souscription du pack RFE a échoué. Veuillez réessayer."
}
